import { useState, useEffect } from "react";
import React from "react";
import { ClearChatIcon, DisabledGridIcon, EndChatIcon, FaceBookIcon, LiveChatMenuIcon, LiveChatMinimizeIcon, LiveChatMuteIcon, LiveChatUnmuteIcon, MessageDeliveredIcon, NotificationActiveIcon, NotificationDisableIcon, SendChatTranscrpt, WhatsAppIcon } from "../../icon";
import Avatar from "../shared/avatar.component";
import LiveChatHeaderLogo from "../../icons/live-chat-header-logo.svg";
import { MenuItemRender } from "../shared/menu-item-render";
import { LiveChatService } from "../../services/channels/LiveChatService";
import setToast from "../../helpers/toaster.helper";
import { ToasterTexts } from "../shared/constants";
import { ToasterType } from "../shared/toaster/toaster.model";
import { WidgetTitle } from "../../models/channels/channels.model";

interface Props {
    ClearChat?: () => void;
    EndChat?: () => void;
    Title: string;
    IsMobile: boolean;
    Icon?: string;
    ValidatedUrl: string;
    IsLogedUser?: boolean;
    UserID?: string;
    LatestSession?: number;
    SetShowEmojis?: (boolean) => void;
    IsShareToChatLink?: boolean;
    Status?: "online" | "offline";
    SoundsOn?: boolean;
    HandleSoundsOn?: (sounds: boolean) => void;
    IsOrgnizationActive: boolean;
    LivechatTheme: string;
    WidgetType?: number;
    HeaderTextColor: string;
    IsLoginComponent: boolean;
    FaceBookUrl?: string;
    WhatsappUrl?: string;
}


const LiveChatPageHeaderComponent: React.FC<Props> = (props: Props) => {

    const optionData =
        [
            {
                Name: "Refresh Chat",
                Icon: ClearChatIcon,
                OnClick: () => { props.ClearChat() },
            },
            {
                Name: "Send Chat Transcript",
                Icon: SendChatTranscrpt,
                Hide: !props.IsLogedUser,
                OnClick: () => { sendTranscript() },
            },
            {
                Name: "End Chat",
                Icon: EndChatIcon,
                OnClick: () => { props.EndChat() },
            },
            {
                Name: props.SoundsOn ? "Sounds Off" : "Sounds On",
                Icon: props.SoundsOn ? LiveChatMuteIcon : LiveChatUnmuteIcon,
                OnClick: () => { props.HandleSoundsOn(!props.SoundsOn) },
            },
        ]

    const handleCloseWidget = () => {
        props.SetShowEmojis(false)
        localStorage.setItem('widgetClosed', "true")
        window.parent.postMessage({ action: 'callParentFunction', message: 'Hello from iframe!' }, "*");
    }

    const sendTranscript = () => {
        LiveChatService.sendChatTranscript(props.UserID, props.LatestSession).then((res) => {
            setToast("chat history has been sent to registered mail", ToasterType.SUCCESS)
        }).catch((err) => {
            setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER)

        })
    }

    const handleToOpen = (url?: string) => {
        window.open(url, '_blank')
    }

    return (
        <div className={` ${props.IsMobile ? "min-h-8" : "min-h-11"} d-flex color-secondary flex-direction ${props.HeaderTextColor === "#ODODOD" ? "color-primary-accent" : "color-secondary"}`} style={{ background: props.LivechatTheme }}>
            <div className="w-p-100 h-p-100 d-flex justify-between">
                {props.WidgetType === WidgetTitle.NAME_AND_LOGO && < div className={`${!props.IsMobile && props.IsShareToChatLink ? "w-p-7 min-w-7" : "w-p-20"} d-flex justify-center align-center`}>
                    <Avatar ImgSrc={!!props.Icon ? props.Icon : ""} Size={props.IsMobile ? 30 : 40} Name={props.Title} className=" d-flex justify-center align-center" />
                </div >
                }
                <div className={`${!props.IsMobile && props.IsShareToChatLink ? "w-p-83" : "w-p-60"} d-flex justify-center  flex-direction ${props.WidgetType === WidgetTitle.NAME_AND_LOGO ? "" : "ml-2"} ${props.HeaderTextColor === "#ODODOD" ? "color-primary-accent" : "color-secondary"}`}>
                    <div className={`w-p-100 h-p-35 d-flex align-center r-h2-regular `}>
                        {props.Title ? `${props.Title.length > (props.IsMobile ? 21 : 30) ? props.Title.slice(0, props.IsMobile ? 18 : 28) + "..." : props.Title}` : "Run"}
                    </div>
                    {props.IsOrgnizationActive ?
                        <div className={`br-2 d-flex align-center r-h6-regular`}>
                            <MessageDeliveredIcon className={"mr-1"} />
                            Online
                        </div>
                        :
                        <div className={`br-2 d-flex align-center r-h6-regular`}>
                            <DisabledGridIcon className={"mr-1"} />
                            Offline
                        </div>
                    }
                </div >
                <div className="d-flex w-p-20 justify-around">{
                    !props.IsShareToChatLink ?
                        <div className={`${!props.IsMobile && props.IsShareToChatLink ? "w-p-4 d-flex justify-flex-end align-center" : "w-p-50"} d-flex justify-center align-center`}>
                            <LiveChatMinimizeIcon width={20} height={20} className={"c-pointer"} onClick={handleCloseWidget} />
                        </div> : <div></div>
                }
                    {!props.IsLoginComponent && <div className={`${!props.IsMobile && props.IsShareToChatLink ? "w-p-6" : "w-p-10"} d-flex justify-center align-center`}>
                        <MenuItemRender MenuData={optionData} MeetBallIcon={LiveChatMenuIcon} ClassName={"w-3 h-3 d-flex justify-center mr-1"} />
                    </div>}
                </div>
            </div>
            {(!!props.WhatsappUrl || !!props.FaceBookUrl) && <div className="d-flex align-center ml-1 h-6">
                <div className={`ml-2  ${props.IsMobile ? "r-h4-medium" : "r-h6-medium"}`}>Connect with</div>
                {!!props.FaceBookUrl && <FaceBookIcon width={props.IsMobile ? 35 : 20} height={props.IsMobile ? 35 : 20} className={`${props.IsMobile ? "mx-2" : "mx-1"} c-pointer`} onClick={() => handleToOpen(props.FaceBookUrl)} />}
                {!!props.WhatsappUrl && <WhatsAppIcon width={props.IsMobile ? 35 : 20} height={props.IsMobile ? 35 : 20} onClick={() => handleToOpen(props.WhatsappUrl)} className="c-pointer" />}
            </div>
            }
            <div className="w-p-100 h-2">
                <div className="w-p-100 h-p-100 bg-color-live-chat-widget-hist-background" style={{borderRadius: "50px 50px 0 0"}}></div>
            </div>
        </div >
    )
}
export default LiveChatPageHeaderComponent;